import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, mappingResultError } from '@digibricks/domains';
export var UPDATE_QUESTION_REPORT_BOOKMARK_USE_CASE = 'UPDATE_QUESTION_REPORT_BOOKMARK_USE_CASE';
export var UpdateQuestionReportBookmarkUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateQuestionReportBookmarkUseCase, _UseCase);

  var _super = _createSuper(UpdateQuestionReportBookmarkUseCase);

  function UpdateQuestionReportBookmarkUseCase(reportRepository) {
    var _this;

    _classCallCheck(this, UpdateQuestionReportBookmarkUseCase);

    _this = _super.call(this);
    _this.reportRepository = reportRepository;
    return _this;
  }

  _createClass(UpdateQuestionReportBookmarkUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var assignmentId, questionReportId, questionReports, responseOrError, questionReportToUpdate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assignmentId = input.assignmentId, questionReportId = input.questionReportId, questionReports = input.questionReports;
                _context.next = 3;
                return this.reportRepository.updateQuestionReportBookmark(assignmentId, questionReportId);

              case 3:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 6:
                questionReportToUpdate = questionReports.find(function (questionReport) {
                  return questionReport.id.toString() === questionReportId;
                });

                if (questionReportToUpdate) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", Result.ok(questionReports));

              case 9:
                questionReportToUpdate.updateBookmark();
                return _context.abrupt("return", Result.ok(_toConsumableArray(questionReports)));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateQuestionReportBookmarkUseCase;
}(UseCase);